import React, { useCallback, useState } from 'react'

import MobileSelectTripOrigin from './EditTripDetails/MobileSelectTripOrigin'

import { UpdateTripError } from 'tripPlanner/api/types'
import { useUpdateTrip } from 'tripPlanner/hooks/api'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'

interface Props {
  tripId: string
  tripOrigin?: { id: string; name: string }
}

const MobileUpdateTripOrigin = ({ tripId, tripOrigin }: Props) => {
  const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined)

  const { closeModal } = useModalCallbacks()

  const { mutate, isLoading: isSaving } = useUpdateTrip({
    onSuccess: () => {
      closeModal()
    },
    onError: (e: UpdateTripError) => {
      if (e.status === 422) {
        setErrorMsg('Error updating departure location')
      }
    },
  })

  const onSave = useCallback(
    ({ id }: { id: string; name: string }) => {
      mutate({
        tripId,
        originPlaceId: id,
      })
    },
    [mutate, tripId],
  )

  const onRemove = useCallback(() => {
    mutate({
      tripId,
      originPlaceId: null,
    })
  }, [mutate, tripId])

  const clearError = useCallback(() => {
    setErrorMsg(undefined)
  }, [])

  return (
    <MobileSelectTripOrigin
      title="Edit departure location"
      tripOrigin={tripOrigin}
      onCancel={closeModal}
      onChange={onSave}
      onRemove={onRemove}
      isSubmitting={isSaving}
      errorMsg={errorMsg}
      onRequestClearError={clearError}
    />
  )
}

export default MobileUpdateTripOrigin
